// extracted by mini-css-extract-plugin
export default {"container":"VersionSelect_container__PSask"};